interface BusinessEmailAllowlistEntry {
  domain: string;
  falsePositiveReason: string;
  trackingIssue: string;
}

const businessEmailAllowlistEntries: readonly BusinessEmailAllowlistEntry[] = [];

export const businessEmailAllowlist: ReadonlySet<string> = new Set(
  businessEmailAllowlistEntries.map(({ domain }) => domain),
);

export const consumerEmailDomains: ReadonlySet<string> = new Set([
  '163.com',
  'aol.com',
  'daum.net',
  'fastmail.com',
  'fastmail.fm',
  'gmail.com',
  'gmx.com',
  'gmx.de',
  'gmx.net',
  'googlemail.com',
  'hotmail.co.uk',
  'hotmail.com',
  'hotmail.de',
  'icloud.com',
  'interia.pl',
  'live.com',
  'mac.com',
  'mail.com',
  'mail.ru',
  'me.com',
  'msn.com',
  'naver.com',
  'o2.pl',
  'onet.pl',
  'outlook.com',
  'outlook.de',
  'pm.me',
  'proton.me',
  'protonmail.ch',
  'protonmail.com',
  'qq.com',
  'rocketmail.com',
  'seznam.cz',
  'tuta.com',
  'tutanota.com',
  'tutanota.de',
  'tutamail.com',
  'wp.pl',
  'yahoo.com',
  'yandex.com',
  'ymail.com',
  'zoho.com',
]);

export const getWorkEmailDomain = (workEmail: string): string => {
  const separatorIndex = workEmail.lastIndexOf('@');

  return workEmail.slice(separatorIndex + 1).toLowerCase();
};

export const isBusinessEmailDomainAllowlisted = (domain: string): boolean =>
  businessEmailAllowlist.has(domain);

export const isConsumerWorkEmail = (workEmail: string): boolean => {
  const domain = getWorkEmailDomain(workEmail);

  return !isBusinessEmailDomainAllowlisted(domain) && consumerEmailDomains.has(domain);
};
